<template>
    <transition name="modal-fade">
        <div class="modal-backdrop">
            <div class="modal-wrapper">
                <div 
                    class="modal-container rounded-8" 
                    :class="sizeClass"
                    role="dialog" 
                    :aria-labelledby="ariaLabelledby"
                >
                    <header class="modal-header bg-utel-v2-secondary text-primary">
                        <slot name="header">
                            <strong>{{ title }}</strong>
                        </slot>
                        <button 
                            type="button" 
                            class="btn btn-close" 
                            @click="close" 
                            aria-label="Close modal"
                        ></button>
                    </header>

                    <section class="modal-body">
                        <slot></slot>
                    </section>

                    <footer class="modal-footer" v-if="$slots.footer || showDefaultFooter">
                        <slot name="footer">
                            <button 
                                type="button" 
                                class="btn text-primary bg-utel-v2-secondary mx-3 rounded-8" 
                                @click="close"
                            >
                                {{ cancelText }}
                            </button>
                            <button 
                                v-if="showConfirmButton"
                                type="button" 
                                class="btn text-white bg-utel rounded-8" 
                                :disabled="confirmDisabled"
                                @click="confirm"
                            >
                                <span v-if="confirmDisabled && showSpinner" class="spinner-border spinner-border-sm me-1"></span>
                                {{ confirmDisabled && loadingText ? loadingText : confirmText }}
                            </button>
                        </slot>
                    </footer>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: 'BaseModal',
    props: {
        title: { type: String, default: '' },
        size: { type: String, default: 'md', validator: v => ['sm', 'md', 'lg'].includes(v) },
        showDefaultFooter: { type: Boolean, default: true },
        showConfirmButton: { type: Boolean, default: true },
        confirmText: { type: String, default: 'Guardar cambios' },
        loadingText: { type: String, default: 'Guardando...' },
        cancelText: { type: String, default: 'Cancelar' },
        confirmDisabled: { type: Boolean, default: false },
        showSpinner: { type: Boolean, default: true },
        ariaLabelledby: { type: String, default: 'modalTitle' }
    },
    computed: {
        sizeClass() {
            return `modal-${this.size}`;
        }
    },
    methods: {
        close() {
            this.$emit('close');
        },
        confirm() {
            this.$emit('confirm');
        }
    }
};
</script>

<style scoped>
.modal-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9998;
}

.modal-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
}

.modal-container {
    background: #FFFFFF;
    box-shadow: 2px 2px 20px 1px rgba(0, 0, 0, 0.2);
    display: flex;
    flex-direction: column;
    max-height: 90vh;
    overflow: hidden;
}

.modal-sm { max-width: 400px; width: 90%; }
.modal-md { max-width: 600px; width: 90%; }
.modal-lg { max-width: 900px; width: 90%; }

.modal-header,
.modal-footer {
    padding: 15px;
    display: flex;
}

.modal-header {
    border-bottom: 1px solid #eeeeee;
    justify-content: space-between;
    align-items: center;
}

.modal-footer {
    border-top: 1px solid #eeeeee;
    justify-content: flex-end;
}

.modal-body {
    padding: 20px;
    overflow-y: auto;
    flex: 1;
}

.modal-fade-enter,
.modal-fade-leave-to {
    opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
    transition: opacity .3s ease;
}

.modal-fade-enter .modal-container,
.modal-fade-leave-to .modal-container {
    transform: scale(0.9);
}

.modal-fade-enter-active .modal-container,
.modal-fade-leave-active .modal-container {
    transition: transform .3s ease;
}
</style>
